import { combineReducers } from 'redux'
import {
  activeMunicipality,
  valuesByMunicipality
} from 'components/map/reducer'
import { requestStatus } from 'components/loadingIndicator/reducer'
import { categorySelection, brackets } from 'components/selector/reducer'
import { popupReducer as popup } from 'components/popup/reducer'
import { reducer as interactionCapabilities } from 'components/interactionCapabilities/reducer'
import { extents, overallExtents } from 'components/scale/reducer'
import { filter } from 'components/list/reducer'
import { StateType } from 'typesafe-actions'

export const rootReducer = combineReducers({
  valuesByMunicipality,
  activeMunicipality,
  requestStatus,
  categorySelection,
  popup,
  interactionCapabilities,
  extents,
  overallExtents,
  brackets,
  filter
})

export type AppState = StateType<typeof rootReducer>
